import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFlashlightFilled = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.68 9.056h-10c-.938 0-1.68.737-1.68 1.667v2.481c0 .93.742 1.668 1.68 1.668h10c.234 0 .39-.194.39-.427V9.482c0-.232-.156-.426-.39-.426m-3.75-.388h2.5c.234 0 .39-.194.39-.427v-.814c0-.233-.156-.427-.39-.427h-2.5a.43.43 0 0 0-.43.427v.814c0 .233.195.427.43.427m11.64-1.24h-5c-1.133 0-2.07.93-2.07 2.054v4.963c0 1.124.937 2.055 2.07 2.055h5c.234 0 .43-.155.43-.388V7.816c0-.233-.196-.389-.43-.389m-.404 8.257h-.86V8.24h.86z"
      />
    </svg>
  );
};
export default SvgFlashlightFilled;
